<script>
export default {
  created() {
    setTimeout(() => {
      // 判断是否顶层已有应用打开了
      let hasApp = this.$Application.proc.getLinkAppName();
      let isAdmin = this.$Auth.isAdmin();
      // 判断管理员
      if (isAdmin && !hasApp) {
          this.$Application.run("desktop");
      }
      // 判断普通用户
      if(!hasApp && !isAdmin){
          this.$Application.run("select-project-view");
      }
      if(hasApp){
        this.$Auth.proc.on('login',()=>{
          this.$Application.openDecryptPage()
        })
        
      }
    });

    document.addEventListener("keydown", (e) => {
      try {
        switch (e.key.toLocaleUpperCase()) {
        case "F2":
        e.preventDefault()
          // 开启桌面
          if(this.$Auth.isAdmin()){
            this.$Application.toggle("desktop");
          }
          break;
        case "F12":
        // e.preventDefault()
          // console.log("不予许f12");
          // this.$Application.toggle('xbt-setting-view')
          break;
        
      }
      } catch (error) {
        
      }
      
    });
  },
  render(h) {
    return h("");
  }
};
</script>